/**
 * Очаг: постановка (§Т2.9).
 */

import { apiFetch } from "./client.js";

export type HearthView = {
  readonly hexId: string;
  readonly hearthTz: string;
  readonly placedAt: string;
  readonly moveAvailableAt: string;
};

export async function fetchHearth(token: string, signal?: AbortSignal): Promise<HearthView> {
  return apiFetch<HearthView>("/hearth", { token, ...(signal ? { signal } : {}) });
}

export async function placeHearth(
  hexId: string,
  token: string,
  idempotencyKey: string,
): Promise<HearthView> {
  return apiFetch<HearthView>("/hearth", {
    method: "POST",
    token,
    headers: { "Idempotency-Key": idempotencyKey },
    body: JSON.stringify({ hexId }),
  });
}

export async function moveHearth(
  hexId: string,
  token: string,
  idempotencyKey: string,
): Promise<HearthView> {
  return apiFetch<HearthView>("/hearth/move", {
    method: "POST",
    token,
    headers: { "Idempotency-Key": idempotencyKey },
    body: JSON.stringify({ hexId }),
  });
}
